import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import UserAvatar from '@wix/da-shared-react/pkg/User/Avatar';
import UserLink from '@wix/da-shared-react/pkg/User/Link';
import { PapiUser } from '@wix/da-types-papi';
import AvatarEdit from './AvatarEdit';
import ProfileIdentityMobile from '@wix/da-shared-react/pkg/ProfileIdentityMobile';
import ProfileStats from './ProfileStats';

import s from './ProfileIdentity.scss';
import { withMobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';

export interface Props {
  profileOwnerUser: PapiUser;
  stats: object;
  tagline: string;
  url: string;
  className?: string;
  isCurrentUserProfileOwner: boolean;
  isMobile?: boolean;
}

class ProfileIdentity extends React.Component<Props & WithTranslation> {
  renderDesktop() {
    const { profileOwnerUser, stats, tagline, className } = this.props;
    return (
      <div className={classnames(s['root'], className)}>
        {this.props.isCurrentUserProfileOwner && <AvatarEdit />}
        <span>
          <UserAvatar
            user={profileOwnerUser}
            className={s['user-avatar']}
            withTooltip={false}
          />
        </span>
        <div className={s['user-details']}>
          <div className={s['user-link']}>
            <UserLink
              className={s['user-link-text']}
              symbolClassName={s['user-link-icon']}
              user={profileOwnerUser}
              withTooltip={false}
            />
          </div>
          {tagline && <div className={s['user-label']}>{tagline}</div>}
          <ProfileStats {...stats} />
        </div>
      </div>
    );
  }

  renderMobile() {
    const { profileOwnerUser, stats, tagline, className } = this.props;
    return (
      <ProfileIdentityMobile
        user={profileOwnerUser}
        tagline={tagline}
        className={className}
        statsComponent={<ProfileStats {...stats} />}
      />
    );
  }

  render() {
    return this.props.isMobile ? this.renderMobile() : this.renderDesktop();
  }
}

export default withMobileContext(withTranslation()(ProfileIdentity));
